import { useEffect, useState } from "react";
import { UpgradeToPremiumModal } from "./upgrade-to-premium-modal";
import { InterruptionModal } from "./interruption-modal";
import { useApp } from "@/app/providers/app-provider";
import type { ModalIds } from "@/lib/audio/application/stores/appStore";

const ModalController = () => {
	const { openedModalId, handleModalOpen } = useApp();

	const closeModal = () => {
		handleModalOpen(openedModalId, false);
	};

	return (
		<>
			<InterruptionModal
				isOpen={openedModalId === "INTERRUPTION_MODAL"}
				close={closeModal}
			/>
			<UpgradeToPremiumModal
				isOpen={openedModalId === "UPGRADE_MODAL"}
				close={closeModal}
			/>
		</>
	);
};

export default ModalController;
